/**
 * What kind of climbing a crag's route is. The same names, in the same order, as
 * `Climb#route_types`, which is append only: a new one goes last in both, with an
 * icon in `RouteTypeIcon` and a label under `routeTypes` in the locales.
 */
export const ROUTE_TYPES = [
  'slab',
  'overhanging_face',
  'low_angle',
  'overhang',
  'roof',
  'traverse',
  'pockets',
  'crimps',
  'endurance',
  'crux',
  'dyno',
] as const;

export type RouteType = (typeof ROUTE_TYPES)[number];

/**
 * Those this build can draw and name, in the panel's order. A tab open across a
 * release can be sent one it has no icon for, and a cached payload none at all.
 */
export function knownRouteTypes(types: readonly string[] | null | undefined): RouteType[] {
  return ROUTE_TYPES.filter((type) => types?.includes(type));
}
